import Loading from './Loading';
import './Loading.css';

export default Loading;



// WEBPACK FOOTER //
// ./src/shared/components/Loading/index.js